export enum DiagnosisAnswers {
  NONE_APPLY = 'No, none of these apply to me',
}
